export default __webpack_public_path__ + "static/media/gallery-wip-neck_07.9ec6a50d.jpg";